<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('DOCUMENTOS'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      showModalResponsavel: false,
      showModalVisualizarProcesso: false,
      protocolo: null,
      processoTrocado: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      configuracaoFiltro: {},
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        {
          id: 5, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Upload do termo ou contrato', icone: 'fa-upload', codigo: 'UPLOAD_TERMO_CONTRATO', ordem: 1, show: this.showUploadContrato },
            { id: 3, nome: 'Acusar entrega', icone: 'fa-upload', codigo: 'ACUSAR_ENTREGA', ordem: 1, show: this.acusarEntrega }
          ]
        }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.init()
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    async UPLOAD_TERMO_CONTRATO (_this, { item }) {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'analise/uploadTermoContrato',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO'
          }
        })
        this.disabledAnalisar = false
      }
    },
    ACUSAR_ENTREGA: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/acusarEntrega',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA'
        }
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.showModalVisualizarProcesso = true
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaDocumentosListagem.vue